import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Seo } from "../components/Seo";

export default function LessonSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sid) { setState("error"); return; }
    let cancelled = false, attempts = 0;
    const poll = async () => {
      if (cancelled) return;
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired") { setState("expired"); return; }
      } catch (e) { console.error("Lesson status poll error:", e); }
      if (attempts < 8) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => { cancelled = true; };
  }, [sid]);

  return (
    <div data-testid="lesson-success-page" className="min-h-screen flex items-center justify-center px-6 pt-24">
      <Seo title="Lesson Booked" description="Lesson booking confirmation." path="/lesson/success" noindex />
      <div className="max-w-lg text-center">
        {state === "checking" && (<><div className="overline">Confirming</div>
          <h1 className="font-display text-5xl mt-4">Holding your slot...</h1></>)}
        {state === "paid" && (<>
          <div className="overline">Booked</div>
          <h1 className="font-display text-6xl mt-4">See you on Trackman.</h1>
          <p className="text-white/70 mt-6">We received your $50. You'll get a confirmation email with the studio address and your locked-in time within 24 hours.</p>
          <Link to="/feed" className="btn-primary mt-10 inline-block" data-testid="lesson-success-back">Back to the Feed</Link>
        </>)}
        {state === "expired" && (<><h1 className="font-display text-5xl">Session expired.</h1>
          <Link to="/lesson" className="btn-primary mt-8 inline-block">Try again</Link></>)}
        {(state === "timeout" || state === "error") && (<>
          <h1 className="font-display text-5xl">Still processing...</h1>
          <p className="text-white/60 mt-4">Refresh in a moment, or email us if it persists.</p>
          <Link to="/lesson" className="btn-ghost mt-8 inline-block">Back</Link></>)}
      </div>
    </div>
  );
}
